import { cn } from "../lib/utils";

export default function Title({ Elem = "h2", children, className = "" }) {
  return (
    <Elem className={cn("text-3.5xl leading-snug font-semibold", className)}>
      {children}
    </Elem>
  );
}
